"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.participantConfigsReducer = void 0;
var getParticipantConfigsForUser_1 = require("./actions/getParticipantConfigsForUser");
var setParticpantConfigsForUser_1 = require("./actions/setParticpantConfigsForUser");
var initialState = { data: {} };
function participantConfigsReducer(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case getParticipantConfigsForUser_1.GET_PARTICIPANT_CONFIGS:
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), (_a = {}, _a[action.keyName] = action.participantConfig, _a)) });
        case setParticpantConfigsForUser_1.SET_PARTICIPANT_CONFIGS:
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), (_b = {}, _b[action.keyName] = action.participantConfig, _b)) });
        default:
            return state;
    }
}
exports.participantConfigsReducer = participantConfigsReducer;
//# sourceMappingURL=participantConfigs.reducer.js.map